import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import withFocusedState from "../../../enhancers/withFocusedState";
import TextField from '../TextField';
import "./SearchField.css";

var SearchField =
/** @class */
function (_super) {
  tslib_1.__extends(SearchField, _super);

  function SearchField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.removeValue = function () {
      _this.props.onChange(undefined, '');
    };

    _this.handleKeyDown = function (event) {
      var _a = _this.props,
          value = _a.value,
          onKeyDown = _a.onKeyDown,
          onSearch = _a.onSearch;
      onKeyDown(event); // ESC

      if (event.keyCode === 27) {
        event.preventDefault();
        event.stopPropagation();

        _this.removeValue(); // ENTER

      } else if (event.keyCode === 13) {
        onSearch(value);
      }
    };

    _this.handleSuffixClick = function () {
      var value = _this.props.value;

      if (value) {
        _this.removeValue();
      }
    };

    _this.renderSuffix = function () {
      var _a;

      var _b = _this.props,
          value = _b.value,
          blockName = _b.blockName,
          focused = _b.focused;
      var iconClassName = blockName + "__icon";
      var searchClassName = cx(iconClassName, (_a = {}, _a[blockName + "__icon--regular"] = !focused, _a[blockName + "__icon--active"] = focused, _a), 'icon-custom-search-thin');
      var removeClassName = cx(iconClassName, blockName + "__icon--remove", 'icon-custom-exit');
      return React.createElement("i", {
        className: value ? removeClassName : searchClassName,
        onClick: _this.handleSuffixClick
      });
    };

    return _this;
  }

  SearchField.prototype.render = function () {
    var _a;

    var _b = this.props,
        onChange = _b.onChange,
        value = _b.value,
        placeholder = _b.placeholder,
        blockName = _b.blockName,
        containerClassName = _b.containerClassName,
        inputClassName = _b.inputClassName,
        onFocus = _b.onFocus,
        onBlur = _b.onBlur,
        isError = _b.isError,
        focused = _b.focused,
        disabled = _b.disabled,
        onSearch = _b.onSearch,
        // eslint-disable-line no-unused-vars
    other = tslib_1.__rest(_b, ["onChange", "value", "placeholder", "blockName", "containerClassName", "inputClassName", "onFocus", "onBlur", "isError", "focused", "disabled", "onSearch"]);

    var className = cx(blockName, containerClassName, blockName + "--" + (value ? 'filled' : 'empty'), (_a = {}, _a[blockName + "--error"] = isError, _a[blockName + "--active"] = focused, _a[blockName + "--disabled"] = disabled, _a));
    return React.createElement("div", {
      className: className
    }, React.createElement(TextField, tslib_1.__assign({}, other, {
      className: cx(blockName + "__textfield", inputClassName),
      isError: isError,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: this.handleKeyDown,
      onChange: onChange,
      value: value,
      placeholder: placeholder,
      suffix: this.renderSuffix()
    })));
  };

  SearchField.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    blockName: PropTypes.string,
    containerClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    // it comes from the withFocusedState enhancer
    focused: PropTypes.bool,
    onSearch: PropTypes.func,
    onKeyDown: PropTypes.func,
    autoFocus: PropTypes.bool,
    isError: PropTypes.bool,
    disabled: PropTypes.bool
  };
  SearchField.defaultProps = {
    value: '',
    placeholder: 'Search',
    blockName: 'nx-searchfield',
    onChange: noop,
    onSearch: noop,
    onKeyDown: noop,
    autoFocus: false,
    isError: false,
    disabled: false
  };
  return SearchField;
}(Component);

export default withFocusedState(SearchField);

try {
  // @ts-ignore
  SearchField.__docgenInfo = {
    "description": "",
    "displayName": "SearchField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}